/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useJsApiLoader, GoogleMap } from '@react-google-maps/api';
import classes from './GoogleMap.module.css';

const Map = props => {
  const { center, zoom, children, googleApiKey, mapTypeId } = props;

  const [map, setMap] = useState(null);

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleApiKey,
  });

  const onLoad = useCallback((map) => {
    // const bounds = new window.google.maps.LatLngBounds();
    // map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = useCallback((map) => {
    setMap(null);
  }, []);

  return (
    <>
      {loadError && (
        <div className={classes.loadingText}>Map cannot be loaded.</div>
      )}

      {isLoaded
        ? (
          <GoogleMap
            mapContainerClassName={classes.mapDiv}
            center={center}
            zoom={zoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
            mapTypeId={mapTypeId || 'roadmap'}
          >
            {children}
          </GoogleMap>
        ) : (
          <div className={classes.loadingText}>Loading map...</div>
        )
      }
    </>
  );

};

export default Map;

Map.propTypes = {
  googleApiKey: PropTypes.string.isRequired,
  center: PropTypes.object,
  zoom: PropTypes.number,
  mapTypeId: PropTypes.string,
};

Map.defaultProps = {
  googleApiKey: '',
  center: { lat: 0, lng: 0 },
  zoom: 10,
  mapTypeId: 'roadmap',
};
